import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	Typography,
	Stack,
	IconButton,
	TextField,
	Box,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { pdf as PDF } from "@react-pdf/renderer";
import "../../../css/empresa_uno/ventas.css";
import pdf from "../../../images/pdf.png";
import buscar_azul from "../../../images/search_azul.png";
import GeneratePdfNotaCotizacion from "../../../Reports/GeneratePdfNotaCotizacion";
import { ApiService } from "../../ApiService";
import { useParams } from "react-router-dom";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import Tooltip from "@mui/material/Tooltip";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from "../../../svg/lupaIcon";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";
import pdfIcon from "../../../images/pdf.png";
import TablesMobile from "../../empresa/TablesMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { GeneratePdfCotizacion } from "./GeneratePdfCotizacion";

export const VnotaCotizacion = ({ selectedSucursal, convertPrice = (() => { }) }) => {
	const [sucursales, setSucursales] = useState([]);
	const [objQNs, setObjQNs] = useState([]);
	const [fechaIni, setFechaIni] = useState(null);
	const [fechaFin, setFechaFin] = useState(null);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	const [pdfModalVisible, setPdfModalVisible] = useState(false);
	const [pdfApiResponse, setPdfApiResponse] = useState({});

	const onPdfModalClose = () => {
		setPdfModalVisible(false);
		setPdfApiResponse({});
	};

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const fetchQNs = async (key_branch, fecha1, fecha2) => {
		const url = `api/company/quotation/notes?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
		const options = { method: "GET" };

		const request_totals = await ApiService.fetchData(url, options);

		if (!request_totals) {
			alert("Error al cargar los datos de ventas del día");
			return;
		}

		setObjQNs(request_totals);
	};


	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		if (fechaIni == null && fechaFin == null) {
			setFechaFin(currentDate);
			setFechaIni(currentDate);
		}

		setSucursales(current_suc);
		fetchQNs(current_suc, fechaIni || currentDate, fechaFin || currentDate);
	}, [selectedSucursal]);

	function handleChange(e, comp) {
		comp === 1 ? setFechaIni(e) : setFechaFin(e);
		fetchQNs(sucursales, comp === 1 ? e : fechaIni, comp === 2 ? e : fechaFin);
	}
	const getPdfCotizacion = async (nota) => {
		const getButtons = [...document.getElementsByTagName('button')];

		getButtons.forEach((item) => item.disabled = true);

		const url = `api/company/quotation/find/${nota}?key_branch=${selectedSucursal}`;
		const option = { method: "GET" };
		const response = await ApiService.fetchData(url, option);

		if (response !== null) {
			setPdfApiResponse(response);
			setPdfModalVisible(true);
		}

		getButtons.forEach((item) => item.disabled = false);
	};
	// Datos estáticos de la tabla
	const totalGeneral = objQNs && objQNs.reduce((acc, note) => (parseFloat(acc) + parseFloat(note.total_sale)).toFixed(2), 0);

	const componentViewPDF = (nota) => {
		return (
			<button
				className="btn-view"
				style={{
					textDecoration: "none",
					color: "#fff",
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "5px 8px",
					backgroundColor: "var(--theme-company)",
					border: "none",
					borderRadius: "50%",
					cursor: "pointer",
				}}
				onClick={() => getPdfCotizacion(nota)}>
				<FontAwesomeIcon icon={faEye} style={{ color: "#fff", fontSize: "15px" }} />
			</button>
		)
	}

	const returnTotal = () => {
		return totalGeneral;
	}

	return (
		<>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Nota de Cotización</h2>

					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<TextField
							label="Fecha Inicial"
							type="date"
							value={fechaIni}
							onChange={(e) => handleChange(e.target.value, 1)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<TextField
							label="Fecha Fin"
							type="date"
							value={fechaFin}
							onChange={(e) => handleChange(e.target.value, 2)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="cotización" />

						<div style={{ display: 'none' }}>
							<button className="btn-add-var">
								<img className="icon-down pdf-icon" src={pdfIcon} alt="pdf" />
								<span className="txt-add">PDF</span>
							</button>
						</div>
					</div>
				</div>
			</div>

			{
				currentSize > 480 ? (
					<div className="table-view-pc">
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										{["Fecha", "N.- Nota", "Cliente", "Cel. de CLIENTE", "Total", "Ver"].map((header) => (
											<TableCell
												key={header}
												sx={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
												{header}
											</TableCell>
										))}
									</TableRow>
								</TableHead>

								<TableBody>
									{objQNs &&
										objQNs.map((note, idx) => (
											<TableRow key={idx}>
												<TableCell align="center">{note.date_quo}</TableCell>
												<TableCell align="center">{note.nro}</TableCell>
												<TableCell align="center">{note.client_name}</TableCell>
												<TableCell align="center">
													<Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
														<Typography>{note.phone}</Typography>
														<a
															href={`https://wa.me/${note.code_phone + "" + note.phone}`}
															target="_blank"
															rel="noopener noreferrer"
															style={{
																backgroundColor: "#25D366",
																borderRadius: "50%",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																width: "24px",
																height: "24px",
																textDecoration: "none",
															}}>
															<WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
														</a>
													</Stack>
												</TableCell>
												<TableCell align="center">{convertPrice(note.total_sale, null, true)}</TableCell>
												<TableCell
													align="center"
													sx={{
														verticalAlign: "middle",
													}}>
													<Tooltip title="Ver Nota de Cotizacion">
														<IconButton onClick={() => getPdfCotizacion(note.authCode)}>
															<RemoveRedEyeRoundedIcon sx={{ color: "#0468fb" }} />
														</IconButton>
													</Tooltip>
												</TableCell>
											</TableRow>
										))}
								</TableBody>

								<TableFooter>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										<TableCell colSpan={3} align="center" sx={{ color: "white", fontWeight: "bold" }}>
											Total
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{convertPrice(totalGeneral)}
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
									</TableRow>
								</TableFooter>
							</Table>
						</TableContainer>
					</div>
				) : (
					<TablesMobile filteredData={(objQNs ?? []).map(obj => ({
						img: obj?.img_product,
						title: obj?.client_name,
						texto: convertPrice(obj?.total_sale),
						other: obj?.date_sale,
						fullPhone: obj?.codePhone + obj?.phone,
						authCode: obj?.authCode,
						code: obj?.codigo,
					}))} profile={false} mode="reportes" functionEspecial={componentViewPDF} facturado={null} returnTotal={returnTotal} />
				)
			}

			<GeneratePdfCotizacion isOpen={pdfModalVisible} themeColor={'var(--theme-company)'} apiResponse={pdfApiResponse} onClose={onPdfModalClose} convertPrice={convertPrice} />
		</>
	);
};
